import React from 'react';
// import { componentService } from 'js/services/component.service';

export const LogoutButton = React.lazy(() => import(/* webpackChunkName: "logout-button" */ './LogoutButton'));

// componentService.registerWebContentComponents({ Logout: LogoutButton });
